const itemCol = document.querySelectorAll('.results-filter-list .col-12');

for (const items of itemCol) {
	const item = items.getElementsByTagName('li');

	if (item.length <= 1) {
		// eslint-disable-next-line no-param-reassign
		items.style.display = 'none';
	}
}
